import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import AOS from 'aos';
import 'aos/dist/aos.css';

import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;


import { createBootstrap } from 'bootstrap-vue-next';

// Add the necessary CSS
import './assets/vendor/bootstrap/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';



// <!-- Vendor CSS Files -->
import './assets/vendor/bootstrap/css/bootstrap.min.css';
import './assets/vendor/bootstrap-icons/bootstrap-icons.css';
import './assets/vendor/aos/aos.css';
import './assets/vendor/fontawesome-free/css/all.min.css';
import './assets/vendor/glightbox/css/glightbox.min.css';
import './assets/vendor/swiper/swiper-bundle.min.css';


// import './assets/vendor/bootstrap/js/bootstrap.bundle.min.js';


// Main CSS file
import './assets/css/main.css';

const app = createApp(App);
app.use(createBootstrap()); // Important
app.use(router);
app.mount('#app');

AOS.init();